import { useUser } from "src/common/context/userContextUtils";
import { COMPANYADMIN } from "src/common/service/users";

export type ExopenAiAccess =
	| { allowed: true }
	| { allowed: false; reason: "no-grant" | "needs-domain-wide-access" };

// WHY only a domain admin: eldvakt answers for the whole domain and enforces the same rule, so change both together.
export function useExopenAiAccess(
	companyDomainId: string | number,
): ExopenAiAccess {
	const { hasPermissions } = useUser();
	if (hasPermissions(companyDomainId, [COMPANYADMIN])) {
		return { allowed: true };
	}
	return {
		allowed: false,
		reason: hasPermissions(companyDomainId, ["ExopenAi"])
			? "needs-domain-wide-access"
			: "no-grant",
	};
}

export function useHasExopenAiAccess(
	companyDomainId: string | number,
): boolean {
	return useExopenAiAccess(companyDomainId).allowed;
}
